const orgOps = {
  en: {
    seats: {
      tabHeaderTitle: 'Seat packs',
      tabHeaderSubtitle: 'Bulk course licenses purchased by this organization',
      newPack: 'Add seat pack',
      loading: 'Loading seat packs...',
      errorFailedToLoad: 'Failed to load seat packs',
      statTotal: 'Total seats',
      statUsed: 'Used seats',
      statAvailable: 'Available seats',
      meterLabel: 'Seats',
      meterCount: '{used} / {total}',
      tableCourse: 'Course',
      tableSeats: 'Seats',
      tableValidity: 'Validity',
      tableStatus: 'Status',
      priceSub: '{price} per seat',
      validFrom: 'From {date}',
      validUntil: 'Until {date}',
      validNoLimit: 'No expiry',
      emptyTitle: 'No seat packs yet',
      emptyDescription: 'Create a seat pack to license bulk seats on a course for this organization.',
      statusActive: 'Active',
      statusInactive: 'Inactive',
      modalCreateTitle: 'New seat pack',
      courseLabel: 'Course',
      coursePlaceholder: 'Select a course...',
      seatsTotalLabel: 'Total seats',
      unitPriceLabel: 'Unit price',
      currencyLabel: 'Currency',
      accessDurationLabel: 'Access duration (days)',
      accessDurationHint: 'Leave blank for no expiry',
      accessDurationFact: 'Access period',
      accessDaysValue: '{count} day(s)',
      validFromLabel: 'Valid from',
      validUntilLabel: 'Valid until',
      notesLabel: 'Notes',
      submit: 'Create seat pack',
      submitting: 'Creating...',
      errorSelectCourse: 'Select a course.',
      errorSeatsTotal: 'Enter a number of seats greater than 0.',
      errorSeatsBelowUsed: 'Total seats cannot be lower than the {used} seats already in use.',
      successCreated: 'Seat pack created',
      errorFailedToCreate: 'Failed to create seat pack',
      detailTitle: 'Seat pack',
      detailLoading: 'Loading seat pack...',
      detailErrorFailedToLoad: 'Failed to load seat pack',
      detailEditTitle: 'Edit pack',
      isActiveLabel: 'Active',
      save: 'Save changes',
      saving: 'Saving...',
      successUpdated: 'Seat pack updated',
      errorFailedToUpdate: 'Failed to update seat pack',
      deleteCta: 'Delete pack',
      deleting: 'Deleting...',
      deleteConfirmTitle: 'Delete this seat pack?',
      deleteConfirmMessage: 'This cannot be undone. Packs with used seats cannot be deleted.',
      successDeleted: 'Seat pack deleted',
      errorFailedToDelete: 'Failed to delete seat pack',
      assignmentsTitle: 'Assignments',
      assignmentsEmpty: 'No seats assigned yet.',
      colUser: 'User',
      colStatus: 'Status',
      colExpires: 'Expires',
      assignStatusActive: 'Active',
      assignStatusReserved: 'Reserved',
      assignStatusRevoked: 'Revoked',
      assignStatusExpired: 'Expired',
    },
    cohorts: {
      tabHeaderTitle: 'Cohorts',
      tabHeaderSubtitle: 'Group members together for tracking and bulk course assignment',
      newCohort: 'Add cohort',
      loading: 'Loading cohorts...',
      errorFailedToLoad: 'Failed to load cohorts',
      tableName: 'Cohort',
      tableCourse: 'Course',
      tableMembers: 'Members',
      tableDates: 'Dates',
      noCourse: 'No course set',
      emptyTitle: 'No cohorts yet',
      emptyDescription: 'Create a cohort to group members and assign them to a course together.',
      modalCreateTitle: 'New cohort',
      nameLabel: 'Cohort name',
      namePlaceholder: 'e.g. 2026 Spring intake',
      courseLabel: 'Course (optional)',
      coursePlaceholder: 'Select a course...',
      courseNone: 'No course',
      startDateLabel: 'Start date',
      endDateLabel: 'End date',
      managerLabel: 'Manager (optional)',
      managerPlaceholder: 'Select a manager...',
      managerNone: 'No manager',
      staffLoadFailed: 'Could not load the staff list.',
      managerLine: 'Manager: {name}',
      submit: 'Create cohort',
      submitting: 'Creating...',
      errorNameRequired: 'Cohort name is required.',
      successCreated: 'Cohort created',
      errorFailedToCreate: 'Failed to create cohort',
      drawerClose: 'Close',
      drawerLoading: 'Loading cohort...',
      drawerErrorFailedToLoad: 'Failed to load cohort',
      sectionRoster: 'Roster',
      sectionBulkAdd: 'Add members',
      sectionAssign: 'Assign to course',
      rosterEmpty: 'No members yet.',
      colMember: 'Member',
      colStatus: 'Status',
      removeMember: 'Remove from cohort',
      removeMemberConfirmTitle: 'Remove {name} from this cohort?',
      removeMemberConfirmMessage: 'They leave the cohort but stay a member of the client. Their course enrollments do not change.',
      removeMemberConfirm: 'Remove',
      successMemberRemoved: 'Member removed from cohort',
      errorFailedToRemoveMember: 'Could not remove the member from the cohort',
      bulkAddHint: 'One email or phone per line, or paste a CSV column.',
      bulkAddPlaceholder: 'ali@company.com\n+998901234567\nvalentina@company.com',
      bulkAddCta: 'Add members',
      bulkAdding: 'Adding...',
      successMembersAdded: 'Members added',
      errorFailedToAddMembers: 'Failed to add members',
      errorNoRows: 'Enter at least one email or phone number.',
      bulkResultsTitle: 'Add members result',
      bulkSummaryLine: '{total} lines · {added} added · {already} already in the cohort · {failed} not added',
      bulkResultAlready: 'Already in cohort',
      bulkResultError: 'Not added',
      bulkReasonEmail: 'Invalid email address',
      bulkReasonPhone: 'Invalid phone number',
      bulkReasonUser: 'User not found',
      bulkReasonOther: 'Could not be added',
      bulkPartialToast: '{added} added, {notAdded} not added. They stay in the box below.',
      assignCourseLabel: 'Course',
      assignCourseDefaultHint: "Defaults to this cohort's course",
      assignSeatPackLabel: 'Seat pack (optional)',
      assignSeatPackPlaceholder: 'Auto-select an eligible pack',
      assignCta: 'Assign cohort to course',
      assigning: 'Assigning...',
      errorFailedToAssign: 'Failed to assign cohort',
      assignResultsTitle: 'Assignment results',
      assignSummaryLine: '{total} processed · {enrolled} enrolled · {attached} attached · {noSeats} no seats · {failed} failed',
      assignResultNoSeats: 'No seats',
      assignResultFailed: 'Failed',
      assignReasonNoSeats: 'No seats left in the pack',
      assignReasonFailed: 'Could not be assigned',
      assignNoPacks: 'There is no active seat pack with free seats for this course. Create one in the Seat packs tab first.',
      assignErrorNoCourse: 'Select a course first.',
      assignErrorNobody: 'No member with an account yet. Add members first, then assign the course.',
      assignConfirmTitle: 'Assign {count} members to {course}?',
      assignConfirmMessage: 'Each one takes a seat from the seat pack and gets access to the course.',
      assignConfirm: 'Assign',
      progressErrorFailedToLoad: 'Failed to load progress',
      progressMemberCount: 'Members',
      progressEnrolled: 'Enrolled',
      progressCompleted: 'Completed',
      progressAvg: 'Avg. progress',
      memberStatusInvited: 'Invited',
      memberStatusEnrolled: 'Joined',
      deleteCta: 'Delete cohort',
      deleting: 'Deleting...',
      deleteConfirmTitle: 'Delete this cohort?',
      deleteConfirmMessage: 'This cannot be undone.',
      successDeleted: 'Cohort deleted',
      errorFailedToDelete: 'Failed to delete cohort',
    },
  },
  ru: {
    seats: {
      tabHeaderTitle: 'Пакеты мест',
      tabHeaderSubtitle: 'Оптовые лицензии на курсы, приобретённые этой организацией',
      newPack: 'Добавить пакет мест',
      loading: 'Загрузка пакетов мест...',
      errorFailedToLoad: 'Не удалось загрузить пакеты мест',
      statTotal: 'Всего мест',
      statUsed: 'Использовано мест',
      statAvailable: 'Доступно мест',
      meterLabel: 'Места',
      meterCount: '{used} / {total}',
      tableCourse: 'Курс',
      tableSeats: 'Места',
      tableValidity: 'Срок действия',
      tableStatus: 'Статус',
      priceSub: '{price} за место',
      validFrom: 'С {date}',
      validUntil: 'До {date}',
      validNoLimit: 'Без срока',
      emptyTitle: 'Пока нет пакетов мест',
      emptyDescription: 'Создайте пакет мест, чтобы лицензировать оптовые места на курс для этой организации.',
      statusActive: 'Активен',
      statusInactive: 'Неактивен',
      modalCreateTitle: 'Новый пакет мест',
      courseLabel: 'Курс',
      coursePlaceholder: 'Выберите курс...',
      seatsTotalLabel: 'Всего мест',
      unitPriceLabel: 'Цена за место',
      currencyLabel: 'Валюта',
      accessDurationLabel: 'Срок доступа (дней)',
      accessDurationHint: 'Оставьте пустым для бессрочного доступа',
      accessDurationFact: 'Срок доступа',
      accessDaysValue: '{count} дн.',
      validFromLabel: 'Действует с',
      validUntilLabel: 'Действует до',
      notesLabel: 'Заметки',
      submit: 'Создать пакет мест',
      submitting: 'Создание...',
      errorSelectCourse: 'Выберите курс.',
      errorSeatsTotal: 'Введите количество мест больше 0.',
      errorSeatsBelowUsed: 'Общее число мест не может быть меньше уже занятых ({used}).',
      successCreated: 'Пакет мест создан',
      errorFailedToCreate: 'Не удалось создать пакет мест',
      detailTitle: 'Пакет мест',
      detailLoading: 'Загрузка пакета мест...',
      detailErrorFailedToLoad: 'Не удалось загрузить пакет мест',
      detailEditTitle: 'Редактировать пакет',
      isActiveLabel: 'Активен',
      save: 'Сохранить изменения',
      saving: 'Сохранение...',
      successUpdated: 'Пакет мест обновлён',
      errorFailedToUpdate: 'Не удалось обновить пакет мест',
      deleteCta: 'Удалить пакет',
      deleting: 'Удаление...',
      deleteConfirmTitle: 'Удалить этот пакет мест?',
      deleteConfirmMessage: 'Это действие нельзя отменить. Пакеты с использованными местами удалить нельзя.',
      successDeleted: 'Пакет мест удалён',
      errorFailedToDelete: 'Не удалось удалить пакет мест',
      assignmentsTitle: 'Назначения',
      assignmentsEmpty: 'Пока нет назначенных мест.',
      colUser: 'Пользователь',
      colStatus: 'Статус',
      colExpires: 'Истекает',
      assignStatusActive: 'Активно',
      assignStatusReserved: 'Зарезервировано',
      assignStatusRevoked: 'Отозвано',
      assignStatusExpired: 'Истекло',
    },
    cohorts: {
      tabHeaderTitle: 'Когорты',
      tabHeaderSubtitle: 'Группируйте участников для отслеживания и массового назначения курсов',
      newCohort: 'Добавить когорту',
      loading: 'Загрузка когорт...',
      errorFailedToLoad: 'Не удалось загрузить когорты',
      tableName: 'Когорта',
      tableCourse: 'Курс',
      tableMembers: 'Участники',
      tableDates: 'Даты',
      noCourse: 'Курс не задан',
      emptyTitle: 'Пока нет когорт',
      emptyDescription: 'Создайте когорту, чтобы сгруппировать участников и назначить им курс вместе.',
      modalCreateTitle: 'Новая когорта',
      nameLabel: 'Название когорты',
      namePlaceholder: 'например, Весенний набор 2026',
      courseLabel: 'Курс (необязательно)',
      coursePlaceholder: 'Выберите курс...',
      courseNone: 'Без курса',
      startDateLabel: 'Дата начала',
      endDateLabel: 'Дата окончания',
      managerLabel: 'Менеджер (необязательно)',
      managerPlaceholder: 'Выберите менеджера...',
      managerNone: 'Без менеджера',
      staffLoadFailed: 'Не удалось загрузить список сотрудников.',
      managerLine: 'Менеджер: {name}',
      submit: 'Создать когорту',
      submitting: 'Создание...',
      errorNameRequired: 'Название когорты обязательно.',
      successCreated: 'Когорта создана',
      errorFailedToCreate: 'Не удалось создать когорту',
      drawerClose: 'Закрыть',
      drawerLoading: 'Загрузка когорты...',
      drawerErrorFailedToLoad: 'Не удалось загрузить когорту',
      sectionRoster: 'Состав',
      sectionBulkAdd: 'Добавить участников',
      sectionAssign: 'Назначить курс',
      rosterEmpty: 'Пока нет участников.',
      colMember: 'Участник',
      colStatus: 'Статус',
      removeMember: 'Убрать из когорты',
      removeMemberConfirmTitle: 'Убрать «{name}» из этой когорты?',
      removeMemberConfirmMessage: 'Он выйдет из когорты, но останется участником клиента. Записи на курсы не изменятся.',
      removeMemberConfirm: 'Убрать',
      successMemberRemoved: 'Участник убран из когорты',
      errorFailedToRemoveMember: 'Не удалось убрать участника из когорты',
      bulkAddHint: 'По одному email или телефону на строку, либо вставьте столбец CSV.',
      bulkAddPlaceholder: 'ali@company.com\n+998901234567\nvalentina@company.com',
      bulkAddCta: 'Добавить участников',
      bulkAdding: 'Добавление...',
      successMembersAdded: 'Участники добавлены',
      errorFailedToAddMembers: 'Не удалось добавить участников',
      errorNoRows: 'Введите хотя бы один email или номер телефона.',
      bulkResultsTitle: 'Результат добавления',
      bulkSummaryLine: '{total} строк · добавлено: {added} · уже в когорте: {already} · не добавлено: {failed}',
      bulkResultAlready: 'Уже в когорте',
      bulkResultError: 'Не добавлен',
      bulkReasonEmail: 'Неверный email',
      bulkReasonPhone: 'Неверный номер телефона',
      bulkReasonUser: 'Пользователь не найден',
      bulkReasonOther: 'Не удалось добавить',
      bulkPartialToast: '{added} добавлено, {notAdded} не добавлено. Они остались в поле ниже.',
      assignCourseLabel: 'Курс',
      assignCourseDefaultHint: 'По умолчанию — курс этой когорты',
      assignSeatPackLabel: 'Пакет мест (необязательно)',
      assignSeatPackPlaceholder: 'Автовыбор подходящего пакета',
      assignCta: 'Назначить когорту на курс',
      assigning: 'Назначение...',
      errorFailedToAssign: 'Не удалось назначить когорту',
      assignResultsTitle: 'Результаты назначения',
      assignSummaryLine: 'Обработано: {total} · зачислено: {enrolled} · привязано: {attached} · нет мест: {noSeats} · ошибок: {failed}',
      assignResultNoSeats: 'Нет мест',
      assignResultFailed: 'Ошибка',
      assignReasonNoSeats: 'В пакете не осталось мест',
      assignReasonFailed: 'Не удалось назначить',
      assignNoPacks: 'Для этого курса нет активного пакета со свободными местами. Сначала создайте его на вкладке «Пакеты мест».',
      assignErrorNoCourse: 'Сначала выберите курс.',
      assignErrorNobody: 'В когорте пока нет участников с аккаунтом. Сначала добавьте участников, затем назначьте курс.',
      assignConfirmTitle: 'Назначить участников ({count}) на курс «{course}»?',
      assignConfirmMessage: 'Каждый займёт место из пакета и получит доступ к курсу.',
      assignConfirm: 'Назначить',
      progressErrorFailedToLoad: 'Не удалось загрузить прогресс',
      progressMemberCount: 'Участники',
      progressEnrolled: 'Зачислено',
      progressCompleted: 'Завершено',
      progressAvg: 'Средний прогресс',
      memberStatusInvited: 'Приглашён',
      memberStatusEnrolled: 'В организации',
      deleteCta: 'Удалить когорту',
      deleting: 'Удаление...',
      deleteConfirmTitle: 'Удалить эту когорту?',
      deleteConfirmMessage: 'Это действие нельзя отменить.',
      successDeleted: 'Когорта удалена',
      errorFailedToDelete: 'Не удалось удалить когорту',
    },
  },
  uz: {
    seats: {
      tabHeaderTitle: "O'rin paketlari",
      tabHeaderSubtitle: "Ushbu tashkilot tomonidan sotib olingan ommaviy kurs litsenziyalari",
      newPack: "O'rin paketi qo'shish",
      loading: "O'rin paketlari yuklanmoqda...",
      errorFailedToLoad: "O'rin paketlarini yuklab bo'lmadi",
      statTotal: "Jami o'rinlar",
      statUsed: "Band o'rinlar",
      statAvailable: "Bo'sh o'rinlar",
      meterLabel: "O'rinlar",
      meterCount: '{used} / {total}',
      tableCourse: 'Kurs',
      tableSeats: "O'rinlar",
      tableValidity: 'Amal qilish muddati',
      tableStatus: 'Holat',
      priceSub: "{price} / o'rin",
      validFrom: '{date} dan',
      validUntil: '{date} gacha',
      validNoLimit: 'Muddatsiz',
      emptyTitle: "Hali o'rin paketlari yo'q",
      emptyDescription: "Ushbu tashkilot uchun kursga ommaviy o'rinlarni litsenziyalash uchun o'rin paketi yarating.",
      statusActive: 'Faol',
      statusInactive: 'Nofaol',
      modalCreateTitle: "Yangi o'rin paketi",
      courseLabel: 'Kurs',
      coursePlaceholder: 'Kursni tanlang...',
      seatsTotalLabel: "Jami o'rinlar",
      unitPriceLabel: 'Bir o\'rin narxi',
      currencyLabel: 'Valyuta',
      accessDurationLabel: 'Kirish muddati (kun)',
      accessDurationHint: "Muddatsiz uchun bo'sh qoldiring",
      accessDurationFact: 'Kirish muddati',
      accessDaysValue: '{count} kun',
      validFromLabel: 'Boshlanish sanasi',
      validUntilLabel: 'Tugash sanasi',
      notesLabel: 'Izohlar',
      submit: "O'rin paketini yaratish",
      submitting: 'Yaratilmoqda...',
      errorSelectCourse: 'Kursni tanlang.',
      errorSeatsTotal: "0 dan katta o'rinlar sonini kiriting.",
      errorSeatsBelowUsed: "Jami o'rinlar soni band qilingan {used} ta o'rindan kam bo'lishi mumkin emas.",
      successCreated: "O'rin paketi yaratildi",
      errorFailedToCreate: "O'rin paketini yaratib bo'lmadi",
      detailTitle: "O'rin paketi",
      detailLoading: "O'rin paketi yuklanmoqda...",
      detailErrorFailedToLoad: "O'rin paketini yuklab bo'lmadi",
      detailEditTitle: 'Paketni tahrirlash',
      isActiveLabel: 'Faol',
      save: "O'zgarishlarni saqlash",
      saving: 'Saqlanmoqda...',
      successUpdated: "O'rin paketi yangilandi",
      errorFailedToUpdate: "O'rin paketini yangilab bo'lmadi",
      deleteCta: "Paketni o'chirish",
      deleting: "O'chirilmoqda...",
      deleteConfirmTitle: "Ushbu o'rin paketini o'chirasizmi?",
      deleteConfirmMessage: "Bu amalni bekor qilib bo'lmaydi. Band o'rinlari bor paketlarni o'chirib bo'lmaydi.",
      successDeleted: "O'rin paketi o'chirildi",
      errorFailedToDelete: "O'rin paketini o'chirib bo'lmadi",
      assignmentsTitle: 'Tayinlashlar',
      assignmentsEmpty: "Hali tayinlangan o'rinlar yo'q.",
      colUser: 'Foydalanuvchi',
      colStatus: 'Holat',
      colExpires: 'Tugaydi',
      assignStatusActive: 'Faol',
      assignStatusReserved: 'Zaxiralangan',
      assignStatusRevoked: 'Bekor qilingan',
      assignStatusExpired: "Muddati o'tgan",
    },
    cohorts: {
      tabHeaderTitle: 'Kogortalar',
      tabHeaderSubtitle: "Kuzatish va ommaviy kursga tayinlash uchun a'zolarni guruhlang",
      newCohort: "Kogorta qo'shish",
      loading: 'Kogortalar yuklanmoqda...',
      errorFailedToLoad: "Kogortalarni yuklab bo'lmadi",
      tableName: 'Kogorta',
      tableCourse: 'Kurs',
      tableMembers: "A'zolar",
      tableDates: 'Sanalar',
      noCourse: "Kurs belgilanmagan",
      emptyTitle: "Hali kogortalar yo'q",
      emptyDescription: "A'zolarni guruhlash va ularga birgalikda kurs tayinlash uchun kogorta yarating.",
      modalCreateTitle: 'Yangi kogorta',
      nameLabel: 'Kogorta nomi',
      namePlaceholder: 'masalan, 2026 Bahor qabul',
      courseLabel: 'Kurs (ixtiyoriy)',
      coursePlaceholder: 'Kursni tanlang...',
      courseNone: 'Kurssiz',
      startDateLabel: 'Boshlanish sanasi',
      endDateLabel: 'Tugash sanasi',
      managerLabel: 'Menejer (ixtiyoriy)',
      managerPlaceholder: 'Menejerni tanlang...',
      managerNone: 'Menejersiz',
      staffLoadFailed: "Xodimlar ro'yxatini yuklab bo'lmadi.",
      managerLine: 'Menejer: {name}',
      submit: 'Kogorta yaratish',
      submitting: 'Yaratilmoqda...',
      errorNameRequired: 'Kogorta nomi majburiy.',
      successCreated: 'Kogorta yaratildi',
      errorFailedToCreate: "Kogorta yaratib bo'lmadi",
      drawerClose: 'Yopish',
      drawerLoading: 'Kogorta yuklanmoqda...',
      drawerErrorFailedToLoad: "Kogortani yuklab bo'lmadi",
      sectionRoster: 'Tarkib',
      sectionBulkAdd: "A'zo qo'shish",
      sectionAssign: 'Kursga tayinlash',
      rosterEmpty: "Hali a'zolar yo'q.",
      colMember: "A'zo",
      colStatus: 'Holat',
      removeMember: 'Kogortadan chiqarish',
      removeMemberConfirmTitle: '{name} kogortadan chiqarilsinmi?',
      removeMemberConfirmMessage: "U kogortadan chiqadi, lekin mijoz a'zosi bo'lib qoladi. Kurslarga yozilishi o'zgarmaydi.",
      removeMemberConfirm: 'Chiqarish',
      successMemberRemoved: "A'zo kogortadan chiqarildi",
      errorFailedToRemoveMember: "A'zoni kogortadan chiqarib bo'lmadi",
      bulkAddHint: 'Har bir qatorda bitta email yoki telefon, yoki CSV ustunini joylashtiring.',
      bulkAddPlaceholder: 'ali@company.com\n+998901234567\nvalentina@company.com',
      bulkAddCta: "A'zo qo'shish",
      bulkAdding: "Qo'shilmoqda...",
      successMembersAdded: "A'zolar qo'shildi",
      errorFailedToAddMembers: "A'zolarni qo'shib bo'lmadi",
      errorNoRows: 'Kamida bitta email yoki telefon raqamini kiriting.',
      bulkResultsTitle: "Qo'shish natijasi",
      bulkSummaryLine: "{total} qator · qo'shildi: {added} · allaqachon kogortada: {already} · qo'shilmadi: {failed}",
      bulkResultAlready: 'Allaqachon kogortada',
      bulkResultError: "Qo'shilmadi",
      bulkReasonEmail: "Email manzili noto'g'ri",
      bulkReasonPhone: "Telefon raqami noto'g'ri",
      bulkReasonUser: 'Foydalanuvchi topilmadi',
      bulkReasonOther: "Qo'shib bo'lmadi",
      bulkPartialToast: "{added} ta qo'shildi, {notAdded} ta qo'shilmadi. Ular quyidagi maydonda qoldi.",
      assignCourseLabel: 'Kurs',
      assignCourseDefaultHint: "Standart holatda ushbu kogortaning kursi",
      assignSeatPackLabel: "O'rin paketi (ixtiyoriy)",
      assignSeatPackPlaceholder: "Mos paket avtomatik tanlanadi",
      assignCta: 'Kogortani kursga tayinlash',
      assigning: 'Tayinlanmoqda...',
      errorFailedToAssign: "Kogortani tayinlab bo'lmadi",
      assignResultsTitle: 'Tayinlash natijalari',
      assignSummaryLine: 'Jami: {total} · yozildi: {enrolled} · bog\'landi: {attached} · o\'rin yo\'q: {noSeats} · xato: {failed}',
      assignResultNoSeats: "O'rin yo'q",
      assignResultFailed: 'Xato',
      assignReasonNoSeats: "Paketda bo'sh o'rin qolmagan",
      assignReasonFailed: "Tayinlab bo'lmadi",
      assignNoPacks: "Bu kurs uchun bo'sh o'rinli faol paket yo'q. Avval «O'rin paketlari» bo'limida paket yarating.",
      assignErrorNoCourse: 'Avval kursni tanlang.',
      assignErrorNobody: "Kogortada hisobi bor a'zo hali yo'q. Avval a'zolarni qo'shing, so'ng kursni tayinlang.",
      assignConfirmTitle: "{count} ta a'zo «{course}» kursiga tayinlansinmi?",
      assignConfirmMessage: "Har biri o'rin paketidan bitta o'rin band qiladi va kursga kirish huquqini oladi.",
      assignConfirm: 'Tayinlash',
      progressErrorFailedToLoad: "Progressni yuklab bo'lmadi",
      progressMemberCount: "A'zolar",
      progressEnrolled: 'Yozilgan',
      progressCompleted: 'Yakunlangan',
      progressAvg: "O'rtacha progress",
      memberStatusInvited: 'Taklif qilingan',
      memberStatusEnrolled: "Qo'shilgan",
      deleteCta: "Kogortani o'chirish",
      deleting: "O'chirilmoqda...",
      deleteConfirmTitle: "Ushbu kogortani o'chirasizmi?",
      deleteConfirmMessage: "Bu amalni bekor qilib bo'lmaydi.",
      successDeleted: "Kogorta o'chirildi",
      errorFailedToDelete: "Kogortani o'chirib bo'lmadi",
    },
  },
};

export default orgOps;
